'use strict';

import EditAddressController from 'common/popup.component/EditAddressController';

require('npm/odometer/themes/odometer-theme-default.css');

const EXPRESS = 'express';
const NORMAL = 'normal';

class QuotesInterCityController {
    /*@ngInject*/
    constructor($mdDialog, $stateParams, $state, orderStore, utils, inventory, $timeout, $scope, $q) {
        _.extend(this, {
            name: 'quotes',
            $stateParams: $stateParams,
            $state: $state,
            $mdDialog: $mdDialog,
            $timeout: $timeout,
            orderStore: orderStore,
            utils: utils,
            inventory: inventory,
            $q: $q,
            $scope: $scope
        });

        this.getChart = this.getChartConstructor();
        this.getOdometer = this.getOdometerConstructor();

        this.showChartHelpText = true;
        this.showCardHelpText = true;

        this.editOrderItemsValuation = false;
        this.editItemValuationCheck = false;
        this.editOrderVehicleItemsValuation = false;
        this.editItemVehicleValuationCheck = false;
        this.orderLoader = this.initialize();

        $scope.$watch(
            () => this.order && this.order.order_time,
            (updatedMoveDateInSeconds) => this.selectQuoteForDate(updatedMoveDateInSeconds)
        )
    }

    initialize() {
        return this.orderStore.getOrderWithQuoteWithRedirectionCheck(this.$stateParams.orderId)
            .then(
                (orderWithQuote) => {
                    this.order = orderWithQuote.order;
                    this.orderQuote = orderWithQuote.quote;
                    this.orderQuote.surges = _.map(this.orderQuote.surges, function(surge) {
                        if(surge.time_slot_1 === 0.0001) {
                            surge.time_slot_1 = 0;
                        }
                        if(surge.time_slot_2 === 0.0001) {
                            surge.time_slot_2 = 0;
                        }
                        if(surge.time_slot_3 === 0.0001) {
                            surge.time_slot_3 = 0;
                        }
                        if(surge.time_slot_4 === 0.0001) {
                            surge.time_slot_4 = 0;
                        }
                        return surge;
                    });

                    if (!this.order.time_slot) {
                        this.order.time_slot = 'time_slot_1';
                    }

                    // If an existing preference is found, use the specified tab
                    // 0 = Normal delivery, 1 = Express delivery
                    const packingPreferenceFromOrder = this.order.user_preference === EXPRESS ? 1 : 0;

                    this.majorDeliveryPreference = packingPreferenceFromOrder;
                    this.indexedItemStatistics = _.indexBy(this.order.item_stats, 'identifier');
                    this.timeSlots = this.orderStore.timeSlots;
                    if(this.order.total_cubic_feet > 150) {
                        this.timeSlots.splice(1,1); // remove 2nd time slot (10am - 12pm)
                    }
                    this.timeSlotIndex = _.indexBy(this.timeSlots, 'value');
                    //for non zero default valuation start
                    //this.orderItemsValuation = this.utils.defaultValuationOf(this.order.property_type, this.order.order_items); 
                    this.orderItemsValuation = 0;
                    this.vehicleItemsValuation = 0;

                    this.flatOrderItems = this.utils.flattenOrderItems(this.order.order_items, this.order.item_stats, this.order.vehicle_statistics, this.order.property_type);
                    this.fragileItems = this.getFragileItems(this.flatOrderItems, this.order.item_stats);
                    this.itemValueColumns = this.getItemValueColumns(
                        this.flatOrderItems,
                        this.order.item_stats,
                        this.getDepreciationFactor(this.flatOrderItems, this.order.property_type, this.order.item_stats, this.order.vehicle_statistics)
                    );
                    this.vehicleValueColumns = this.getVehicleValueColumns(
                        this.flatOrderItems,
                        this.order.vehicle_statistics
                    );

                    this.quotePrices = this.populateQuotePrices(this.orderQuote, this.flatOrderItems, this.order.item_stats, this.order.property_type, this.order.time_slot, this.order);

                    this.selectQuoteForDate(this.order.order_time);

                    this.createChart(this.getChart())
                        .then((chart) => {
                            this.chart = chart;
                        });

                    this.setupOdometer(this.getOdometer())
                        .then((odometer) => {
                            this.odometer = odometer;
                        });
                },
                (error) => this.$q.reject(error)
            );
    }
    /*ODOMETER*/
    getOdometerConstructor() {
        let Odometer = require('odometer');
        return () => {
            return Odometer;
        }
    }
    /*odometer setup*/
    setupOdometer(Odometer) {
        let deferred = this.$q.defer();

        this.$timeout(() => {
            let odometerElement = document.querySelector("[pk-component-id='client-quote-value-big']");
            if(window.innerWidth < 600){
                odometerElement = document.querySelector("[pk-component-id='client-quote-value-small']");
            }

            let odometer = new Odometer({
                el: odometerElement,
                value: _.ceil(this.order.client_quote_value),
                duration: 200,
                format: '(,ddd)',
                theme: 'default'
            });
            deferred.resolve(odometer);
        });
        return deferred.promise;
    }

    updateOdometer() {
        if (!this.odometer) {
            return false;
        }

        this.odometer.update(_.ceil(this.order.client_quote_value, 0));
    }

    /*CHART JS*/
    getChartConstructor() {
        let Chart = require('chart.js');
        return () => {
            return Chart;
        }
    }

    createChart (Chart) {
        /*extending bar chart to dynamically set bar value spacing*/
        Chart.types.Bar.extend({
            name: "BarAlt",
            draw: function(){
                this.options.barValueSpacing = this.chart.width /300;
                Chart.types.Bar.prototype.draw.apply(this, arguments);
            }
        });

        let deferred = this.$q.defer();

        let quoteType = this.quotePrices[this.majorDeliveryPreference];

        const selectedDateKey = this.getSelectedDateKey(this.order.order_time),
            selectedDateIndex = this.getSelectedDateIndex(selectedDateKey, quoteType.labels);

        const baseColor = '#b4e1fd',
            selectedColor = '#439fd9',
            highlightColor = '#439fd9',
            scaleSteps = 1,
            scaleStepWidth = _.ceil(_.max(quoteType.prices)*1.4, -2);

        let chartData = {
            labels : quoteType.labels,
            datasets : [
                {
                    fillColor: baseColor,
                    highlightFill: highlightColor,
                    data : quoteType.prices
                }
            ]
        };

        /* timeout required to wait for creation of canvas element */
        this.$timeout(() => {
            let chartElementId = quoteType.name + "-bar-chart-big";

            if(window.innerWidth < 600) {
                chartElementId = quoteType.name + "-bar-chart-small";
            }

            let chartElement = document.querySelector("[pk-component-id='"+ chartElementId +"']"),
                chartElement2dCanvasContext = chartElement.getContext('2d');

            let chart = new Chart(chartElement2dCanvasContext).BarAlt(chartData, {
                responsive: true,
                scaleOverride: true,
                scaleLabel: (valueObject) => {
                    return this.utils.monetize(valueObject.value);
                },
                scaleSteps: scaleSteps,
                scaleStepWidth: scaleStepWidth,
                scaleStartValue: 0,
                scaleShowVerticalLines: false,
                showTooltips: true,
                tooltipFillColor: '#142f41',
                tooltipFontColor: '#ffffff',
                tooltipFontStyle: 'normal',
                tooltipTemplate: (valueObj) => {
                    return  valueObj.label + ' - ' + this.utils.monetize(valueObj.value);
                },
                tooltipCaretSize: 8,
                tooltipCornerRadius: 0,
                tooltipYPadding: 5,
                tooltipXPadding: 5
            });

            this.colorBarWith(selectedColor, highlightColor, chart.datasets[0].bars[selectedDateIndex]);

            chartElement.onclick = (evt) => {
                this.showChartHelpText = false;
                let selectedBar = chart.getBarsAtEvent(evt)[0];
                if(selectedBar) {
                    _.forEach(chart.datasets[0].bars, (bar) => this.colorBarWith(baseColor, highlightColor,bar));
                    this.colorBarWith(selectedColor, highlightColor,selectedBar);

                    this.$scope.$apply(() => {
                        quoteType.onSelectQuote(selectedBar.label);
                        chart.update();
                        this.updateOdometer();
                    });
                }
            };

            chart.updateBars = (values) => {
                _.forEach(chart.datasets[0].bars, (bar, index) => bar.value = values[index]);
                chart.update();
            };

            deferred.resolve(chart);
        });

        return deferred.promise;
    }

    colorBarWith(fillColor, highlightColor,context) {
        context._saved.fillColor = fillColor;
        context._saved.highlightFill = highlightColor;
        context.fillColor = fillColor;
        context.highlightFill = highlightColor;
    }

    redrawChart() {
        if(this.chart) {
            this.chart.destroy();
        }

        this.createChart(this.getChart())
            .then((chart) => {
                this.chart = chart;
                this.selectQuoteForDate(this.order.order_time);
                this.updateOdometer();
            });
    }

    tabChange (majorDeliveryPreference, itemStatistics) {
        if(!this.orderQuote.express_delivery_feasibility && majorDeliveryPreference === EXPRESS) {
            this.order.user_preference = NORMAL;
        } else {
            this.order.user_preference = majorDeliveryPreference;
        }

        this.redrawChart();
    }

    getFragileItems(inventory, itemStatistics) {
        const itemStats = _.indexBy(itemStatistics, 'id');

        let itemsInInventory = _(inventory)
            .map(item => this.utils.withDescriptionOf(item, 6))
            .filter(item => itemStats[item.item_statistic_id] && !_.isEmpty(itemStats[item.item_statistic_id].special_packing_type))
            .value();

        return _(itemsInInventory)
            .groupBy(item => item.qualifiedName)
            .map((items, itemQualifiedName) => _.extend(this.utils.getItemColumn(itemQualifiedName, items, 6), {quantity: items.length}))
            .sortBy(item => item.name)
            .value();
    }

    getItemValueColumns(inventory, itemStatistics, damageCoverValuationRatio) {
        const itemStats = _.indexBy(itemStatistics, 'id');

        let itemsInInventory = _(inventory)
            .map(item => this.utils.withDescriptionOf(item, 6))
            .value();

        return _(itemsInInventory)
            .filter(item => item.vehicle_statistic_id ? false : true)
            .groupBy(item => item.qualifiedName)
            .map((items, itemQualifiedName) => {
                items = _.map(items, (item) => {
                    // Update item valuation factoring in damage cover factor
                    const statisticId = item.item_statistic_id,
                        stats = itemStats[statisticId];

                    const valuation = stats ? stats.valuation : 0;
                    const adjustedValuation = valuation * damageCoverValuationRatio;

                    item.valuation = 0; //adjustedValuation; is used for non zero property valuation
                    item.defaultValuation = adjustedValuation;
                    return item;
                });
                let column = _.extend(this.utils.getItemColumn(itemQualifiedName, items, 6),
                    items[0],
                    {quantity: items.length}
                );
                column.totalValuation = parseInt(column.quantity * column.valuation, 10);
                return column;
            })
            .map(category => {
                category.counts = {};
                category.counts[category.qualifiedName] = {size: _.sum(category.children, 'quantity')};
                category.package_status = _.every(category.children, {package_status: true});
                return category;
            })
            .groupBy(item => this.utils.getRootNameOf(item, 1))
            .map((children, categoryName) => this.utils.withDescriptionOf({
                qualifiedName: categoryName,
                children: _.sortBy(children, (item) => item.score)
            }, 1))
            .sortBy(category => this.utils.sortMajorCategories(category))
            .value();
    }


    getVehicleValueColumns(inventory, vehicleStatistics) {
        const vehicleStats = _.indexBy(vehicleStatistics, 'id');

        let itemsInInventory = _(inventory)
            .map(item => this.utils.withDescriptionOf(item, 6))
            .value();

        return _(itemsInInventory)
            .filter(item => item.vehicle_statistic_id ? true : false)
            .groupBy(item => item.qualifiedName)
            .map((items, itemQualifiedName) => {
                // Update item valuation factoring in damage cover factor
                items = _.map(items, (item) => {
                    const isVehicle = _.contains(item.qualifiedName, 'cars')
                        || _.contains(item.qualifiedName, 'bikes')
                        || _.contains(item.qualifiedName, 'cycles');

                    const statisticId = item.vehicle_statistic_id || item.item_statistic_id,
                        stats = isVehicle ? vehicleStats[statisticId] : itemStats[statisticId];

                    const valuation = stats ? stats.valuation : 0;

                    const adjustedValuation = valuation;

                    item.valuation = adjustedValuation;
                    item.defaultValuation = adjustedValuation;
                    return item;
                });
                let column = _.extend(this.utils.getItemColumn(itemQualifiedName, items, 6),
                    items[0],
                    {quantity: items.length}
                );
                column.totalValuation = parseInt(column.quantity * column.valuation, 10);
                return column;
            })
            .map(category => {
                category.counts = {};
                category.counts[category.qualifiedName] = {size: _.sum(category.children, 'quantity')};
                category.package_status = _.every(category.children, {package_status: true});
                return category;
            })
            .groupBy(item => this.utils.getRootNameOf(item, 1))
            .map((children, categoryName) => this.utils.withDescriptionOf({
                qualifiedName: categoryName,
                children: _.sortBy(children, (item) => item.score)
            }, 1))
            .sortBy(category => this.utils.sortMajorCategories(category))
            .value();
    }


    getIconForItem(item) {
        const twoPartItemName = this.utils.getRootNameOf(item, 2).split('.'),
            isMiscellaneousItem = twoPartItemName[0] === 'others',
            itemNameForIcon = isMiscellaneousItem ? item.name : twoPartItemName[1],
            cssIconClass = ['piko-icon-', itemNameForIcon.toLowerCase()].join('');

        let cssClasses = {};
        cssClasses[cssIconClass] = true;

        return cssClasses;
    }

    populateQuotePrices(quote, orderItems, itemStatistics, propertyType, timeSlot, order) {
        const labels = {express: 'Express Delivery', normal: 'Normal Delivery'};
        return _.map([NORMAL, EXPRESS], (deliveryPreference, index) => {
            if (deliveryPreference === EXPRESS && !quote.express_delivery_feasibility) {
                return {
                    name: deliveryPreference,
                    displayName: labels[deliveryPreference],
                    disabled: true
                };
            }

            return _.extend(this.calculateQuotePriceFor(quote, deliveryPreference, orderItems, itemStatistics, propertyType, timeSlot), {
                name: deliveryPreference,
                displayName: labels[deliveryPreference],
                deliveryTime: deliveryPreference === NORMAL ? quote.normal_delivery_time : quote.express_delivery_time,
                onSelectQuote: this.onQuoteSelect(index, order)
            });
        });
    }

    calculateQuotePriceFor(quote, quoteType, orderItems, itemStatistics, propertyType, timeSlot) {
        const surges = quote.surges;
        const quotesDates = _(surges)
            .pluck('surge_date')
            .map((dateString) => moment(dateString))
            .value();
        const labelFormat = 'DD MMM';

        return {
            labels: _.map(quotesDates, (date) => date.format(labelFormat)),
            dates: quotesDates,
            prices: _.map(quotesDates, (date, index) => this.getQuotePriceFor(quote, surges[index], quoteType, orderItems, itemStatistics, propertyType, timeSlot))
        }
    }

    getQuotePriceFor(quote, surge, quoteType, orderItems, itemStatistics, propertyType, timeSlot) {
        const quoteParameters = this.flattenQuoteParams(quote);

        const specialPackingCost = this.getSpecialPackingCostFor(orderItems);
        const normalPackingCost = quoteParameters.packing_cost;

        const itemDamageCover = this.getItemDamageCoverFor(orderItems, propertyType);
        const itemTransitInsurance = this.getItemTransitInsuranceCostFor(orderItems, propertyType);
        const vehicleDamageCover = this.getVehicleDamageCoverFor(orderItems, propertyType);
        const vehicleTransitInsurance = this.getVehicleTransitInsuranceCostFor(orderItems, propertyType);
        const specialHandlingCharges = quote.special_handling_charges ? quote.special_handling_charges : 0;
        const vehicleTransportationCost = quoteParameters.vehicle_transportation_cost ? quoteParameters.vehicle_transportation_cost : 0;

        if(surge[timeSlot] === 0) {
            return 0;
        }

        const surgeFactor = surge[timeSlot] || 1;

        const price = surgeFactor
            * (quoteParameters.transportation_cost_source + normalPackingCost + quoteParameters.labour_cost_source)
            + quoteParameters.labour_cost_destination
            + (quoteParameters.transportation_cost_destination || 0)
            + (quoteParameters.transportation_cost_city_to_city || 0)
            + itemDamageCover
            + itemTransitInsurance
            + vehicleDamageCover
            + vehicleTransitInsurance
            + (quoteParameters.car_delivery_charges || 0)
            + (quoteParameters.storage_cost || 0)
            + specialPackingCost
            + specialHandlingCharges
            + vehicleTransportationCost;

        return quoteType === NORMAL ? price : price + (quoteParameters.express_delivery_cost || 0);
    }

    flattenQuoteParams(quote) {
        return  _.extend({},
            quote,
            this.utils.pluckAll(quote, ['labor_rate_source', 'truck_holding_rate_source', 'vehicle_transportation_cost']),
            _.reduce(quote.quote, (accumalator, params) => _.extend(accumalator, params), {})
        );
    }

    getSpecialPackingCostFor(orderItems) {
        return _.sum(orderItems, (item) => {
            let stats = this.indexedItemStatistics[item.identifier];
            return stats && item.is_special_packing && stats.special_packing_cost;
        });
    }

    getItemTransitInsuranceCostFor(orderItems) {
        const actualValuation = _(orderItems).filter(item => item.item_statistic_id).sum('valuation');
        const transitInsuranceFactor = 0.005;

        return actualValuation * transitInsuranceFactor;
    }

    getItemDamageCoverFor(orderItems) {
        const actualValuation = _(orderItems).filter(item => item.item_statistic_id).sum('valuation');
        const damageCoverFactor = 0.03;

        return actualValuation * damageCoverFactor;
    }

    getVehicleTransitInsuranceCostFor(orderItems) {
        const actualValuation = _(orderItems).filter(item => item.vehicle_statistic_id).sum('valuation');
        const transitInsuranceFactor = 0;

        return actualValuation * transitInsuranceFactor;
    }

    getVehicleDamageCoverFor(orderItems) {
        const actualValuation = _(orderItems).filter(item => item.vehicle_statistic_id).sum('valuation');
        const damageCoverFactor = 0.015;

        return actualValuation * damageCoverFactor;
    }
    getDepreciationFactor(orderItems, propertyType, itemStatistics, vehicleStatistics) {
        const itemStats = _.indexBy(itemStatistics, 'id'),
            vehicleStats = _.indexBy(vehicleStatistics, 'id');

        const defaultValuation = this.utils.defaultValuationOf(this.order.property_type, this.order.order_items);
        const actualValuation = _.sum(orderItems, (item) => {
            const isVehicle = _.contains(item.qualifiedName, 'cars')
                || _.contains(item.qualifiedName, 'bikes')
                || _.contains(item.qualifiedName, 'cycles');
            const statisticId = item.vehicle_statistic_id || item.item_statistic_id,
                stats = isVehicle ? vehicleStats[statisticId] : itemStats[statisticId];

            return stats ? stats.valuation : 0;
        });
        return defaultValuation / actualValuation;
    }

    onQuoteSelect(deliveryPreferenceIndex, order) {
        return (quoteDateLabel) => {
            [order.order_time, order.client_quote_value, order.damage_cover, order.insurance] = this.getMoveDateAndPrice(quoteDateLabel, this.quotePrices[deliveryPreferenceIndex]);
        }
    }

    getMoveDateAndPrice (key, quoteType) {
        let indexOfPriceInList = this.getSelectedDateIndex(key, quoteType.labels),
            quotePrice = quoteType.prices[indexOfPriceInList],
            quoteDate = quoteType.dates[indexOfPriceInList],
            damageCover = this.getItemDamageCoverFor(this.flatOrderItems, this.order.property_type),
            insurance = this.getItemTransitInsuranceCostFor(this.flatOrderItems, this.order.property_type);

        // Order time is stored as seconds
        const moveDateInSeconds = parseInt(quoteDate.toDate().getTime() / 1000, 10);

        return [moveDateInSeconds, quotePrice, damageCover, insurance];
    }

    updateAllQuotePrices () {
        let selectedDateKey = this.getSelectedDateKey(this.order.order_time);

        _.forEach([NORMAL, EXPRESS], (deliveryPreference, index) => {
            let prices = this.calculateQuotePriceFor(this.orderQuote, deliveryPreference, this.flatOrderItems, this.order.item_stats, this.order.property_type, this.order.time_slot);
            this.quotePrices[index].prices = prices.prices;
        });

        /*Set current order price*/
        this.quotePrices[this.majorPackingPreference].onSelectQuote(selectedDateKey);

        if (this.chart && this.chart.update) {
            const activeQuotePrices = this.quotePrices[this.majorDeliveryPreference].prices;
            this.chart.updateBars(activeQuotePrices);
        }
        
        this.$timeout(() => {
            this.selectQuoteForDate(this.order.order_time);
            this.vehicleItemsValuation = _(this.flatOrderItems).filter(item => item.vehicle_statistic_id).sum('valuation');
            this.orderItemsValuation = _(this.flatOrderItems).filter(item => item.item_statistic_id).sum('valuation');
            this.updateOdometer();
        });
    }

    updateItemValuation(column) {
        const itemValuation = column.totalValuation / column.quantity;
        _.forEach(column.children, (item) => item.valuation = itemValuation);
        this.updateAllQuotePrices();
    }
    updateVehicleItemValuation(column) {
        const itemValuation = column.totalValuation / column.quantity;
        _.forEach(column.children, (item) => item.valuation = itemValuation);
        this.updateAllQuotePrices();
    }

    updateOrderItemsValuation() {
        let defaultValuation = this.utils.defaultValuationOf(this.order.property_type, this.order.order_items);
        _.forEach(this.itemValueColumns, (column) => {
            _.forEach(column.children, (item) => {
                item.totalValuation = item.quantity * item.defaultValuation * (this.orderItemsValuation/defaultValuation);

                _.forEach(item.children, (childItem) => {
                    childItem.valuation = item.totalValuation/item.quantity;
                })
            })
        });
        /*
        * called so that the insurance and damage cover price change is reflected on the overall quote prices
        * */
        this.updateAllQuotePrices();
    }
    updateItemSpecialPacking(column) {
        _.forEach(column.children, (item) => item.is_special_packing = column.is_special_packing);
        this.updateAllQuotePrices();
    }

    changeAddress (evt) {
        this.$mdDialog.show({
                controller: EditAddressController,
                controllerAs: 'address',
                template: require('common/popup.component/EditAddress.popup.html'),
                locals: {
                    order: this.getUpdatedOrder(this.orderStore.status.QUOTED)
                },
                parent: angular.element(document.body),
                targetEvent: evt,
                clickOutsideToClose: true
            })
            .then((dialog) => {
                let deferred = this.orderStore.saveOrder(dialog.order)
                    .then(
                        () => this.orderLoader = this.initialize(),
                        (error) => this.$q.reject()
                    );
                this.orderLoader = deferred;
                return deferred;
            });
    }

    goToLocation() {
        this.orderLoader = this.orderStore.saveOrder(this.getUpdatedOrder(this.orderStore.status.CONFIRMED))
            .then(
                (order) => {
                    let nextState = this.utils.getAdminStateIfApplicable('base.location');
                    this.$state.go(nextState, {orderId: order.id});
                }
            );
    }

    getSurgeForDateAndTimeSlot(quote, orderTimeInSeconds, timeSlot) {
        const surges = quote.surges;
        const labelFormat = 'DD MMM';
        const indexedSurges = _.indexBy(surges, (surge) => moment(surge.surge_date).format(labelFormat));

        const formattedOrderTime = moment(orderTimeInSeconds * 1000).format(labelFormat);

        const surgeOnDate = indexedSurges[formattedOrderTime];

        return surgeOnDate ? surgeOnDate[timeSlot] : 1;
    }

    editInventory() {
        let order = this.getUpdatedOrder(this.orderStore.status.QUOTED);
        delete order.surge_factor;
        delete order.pay_later;
        delete order.client_quote_value;
        this.orderLoader = this.orderStore.saveOrder(order)
            .then(
                (order) => {
                    let nextState = this.utils.getAdminStateIfApplicable('base.home');
                    this.$state.go(nextState, {orderId: order.id});
                }
            );
    }

    getUpdatedOrder(orderStatus) {
        let updatedInventoryItems = _(this.itemValueColumns.concat(this.vehicleValueColumns))
            .pluck('children')
            .flatten()
            .pluck('children')
            .flatten()
            .map((item) => _.extend(item, {package_status: true})) //packaging status is true for intercity orders
            .value();
        
        let mergedInventoryItems = this.utils.mergeOrderItems(updatedInventoryItems);

        let order = _.cloneDeep(this.order);
        order.order_items = mergedInventoryItems;
        order.order_time = parseInt(new Date(order.order_time * 1000).getTime() / 1000, 10);
        order.surge_factor = this.getSurgeForDateAndTimeSlot(this.orderQuote, order.order_time, order.time_slot);

        /**
         * Update the status as confirmed / finalized to ensure that
         *  a bill is generated for this order.
         */
        order.status = orderStatus;

        return order;
    }

    getSelectedDateIndex (key, dateLabels) {
        return _.findIndex(dateLabels, (dateLabel) => dateLabel === key);
    }

    getSelectedDateKey (moveDateInSeconds) {
        return moment(moveDateInSeconds * 1000).format('DD MMM');
    }

    standardizeDateFormat (moveDateInSeconds) {
        const moveDate = moment(moveDateInSeconds * 1000);
        return {
            date: moveDate.format('DD'),
            day: moveDate.format('dddd'),
            month: moveDate.format('MMMM'),
            year: moveDate.format('YYYY')
        };
    }

    selectQuoteForDate (moveDateInSeconds) {
        if (!moveDateInSeconds) {
            return false;
        }

        const key = this.getSelectedDateKey(moveDateInSeconds);
        this.selectedQuoteDate = this.standardizeDateFormat(moveDateInSeconds);
        [this.order.order_time, this.order.client_quote_value, this.damage_cover, this.order.insurance] = this.getMoveDateAndPrice(key, this.quotePrices[this.majorDeliveryPreference]);
    }

    /* lodash ceil function for use in html */
    ceil(number, percision) {
        return _.ceil(number, percision);
    }

}


export default QuotesInterCityController;


// WEBPACK FOOTER //
// ./client/app/components/quotes-intercity/quotes-intercity.controller.js